module.exports = __webpack_public_path__ + "img/bee001.608f591a.svg";